import React, { useState } from "react";
import { Link } from "react-router-dom";
import styles from "./Payment.module.css";
import { useDispatch } from "react-redux";
import { savePaymentInfo } from "../../redux/actions/orderActions";

const Payment = () => {
  const dispatch = useDispatch();

  const [paymentType, setPaymentType] = useState("");

  const paymentInfo = {
    paymentType: paymentType,
  };

  const handleSavePaymentInfo = () => {
    dispatch(savePaymentInfo(paymentInfo));
  };

  const [background, setBackground] = useState("");
  const [color, setColor] = useState("");

  const saveButton = (value) => {
    setPaymentType(value);
    setBackground("#18254a");
    setColor("white");
  };
  console.log(paymentType);

  return (
    <div className={styles.container}>
      <div className={styles.box}></div>
      <header>
        <Link to="/confirm-info">
          <i className={styles.backIcon + " fas fa-chevron-left"}></i>
        </Link>
        <h1>Payment modes</h1>
      </header>

      <main>
        <h4>Select Payment Mode</h4>
        <div className={styles.inputContainer}>
          <p>
            <div style={{ width: "100%" }} className={styles.textContainer}>
              <button
                style={{
                  backgroundColor:
                    paymentType === "Cash on Pickup" && background,
                  color: paymentType === "Cash on Pickup" && color,
                }}
                onClick={() => saveButton("Cash on Pickup")}
              >
                <h3
                  style={{
                    color: paymentType === "Cash on Pickup" && color,
                  }}
                >
                  Cash on Pickup
                </h3>
                <p
                  style={{
                    color: paymentType === "Cash on Pickup" && color,
                  }}
                >
                  Pay while pick a delivery
                </p>
              </button>
            </div>
          </p>
          <p>
            <div style={{ width: "100%" }} className={styles.textContainer}>
              <button
                style={{
                  backgroundColor:
                    paymentType === "Cash on Delivery" && background,
                  color: paymentType === "Cash on Delivery" && color,
                }}
                onClick={() => saveButton("Cash on Delivery")}
              >
                <h3
                  style={{
                    color: paymentType === "Cash on Delivery" && color,
                  }}
                >
                  Cash on Delivery
                </h3>
                <p
                  style={{
                    color: paymentType === "Cash on Delivery" && color,
                  }}
                >
                  Pay while drop a delivery
                </p>
              </button>
            </div>
          </p>
        </div>
      </main>
      <Link to="/pickup-assigned">
        <button
          className={styles.payment_button}
          onClick={handleSavePaymentInfo}
        >
          Proceed to Payment
        </button>
      </Link>
    </div>
  );
};

export default Payment;
{
  /* <input
              type="checkbox"
              value={paymentType}
              onChange={() => setPaymentType("Cash on Delivery")}
            /> */
}
